import React from 'react';
import { Icon } from '../../components/Icon';
import { Pagination } from '../../components/ui/Pagination';
// import type { Lead } from '../../types/lead';
import type { Contact } from '../../types/contacts';

interface TableProps {
  data: Contact[];
  loading: boolean;
  currentPage: number;
  totalPages: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onRefresh: () => void;

  // onGenerateQR: (personId: string, validationDate: string) => Promise<{ success: boolean, message?: string }>;

}

export const Table: React.FC<TableProps> = ({
  data,
  loading,
  currentPage,
  totalPages,
  pageSize,
  total,
  onPageChange
}) => {


  // const handleView = (empleado: Empleado) => {
  //   alert(`Ver detalles de: ${empleado.nombre}`);
  //   // Implementar navegación a vista de detalles
  // };

  // const handleEdit = (empleado: Empleado) => {
  //   alert(`Editar empleado: ${empleado.nombre}`);
  //   // Implementar navegación a formulario de edición
  // };








  // const handleDelete = async (empleado: Empleado) => {
  //   if (window.confirm(`¿Estás seguro de eliminar a ${empleado.nombre}?`)) {
  //     try {
  //       // Aquí iría la llamada a la API para eliminar
  //       // await visitasApi.deleteEmpleado(empleado.id);
  //       alert(`Empleado ${empleado.nombre} eliminado`);
  //       onRefresh();
  //     } catch (error) {

  //       alert(`Error al eliminar el empleado: ${error}`);
  //     }
  //   }
  // };





  return (
    <div className="card p-1 lg:p-4">


      <div className="overflow-x-auto ">
        <table className="w-full border border-gray-200 ">
          <thead className="bg-gray-50 dark:bg-gray-700 ">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Modificado
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Nombre
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Telefono
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Email
              </th>

              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {loading ? (
              <tr>
                <td colSpan={7} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <Icon name="loading" className="h-8 w-8 text-primary animate-spin" />
                    <span className="text-gray-600 dark:text-gray-300">Cargando visitas...</span>
                  </div>
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <Icon name="users" className="w-12 h-12 text-gray-400" />
                    <span className="text-gray-500 dark:text-gray-400 text-lg">
                      No se encontraron leads
                    </span>
                    <span className="text-gray-400 dark:text-gray-500 text-sm">
                      Intenta ajustar los filtros de búsqueda
                    </span>
                  </div>
                </td>
              </tr>
            ) : (
              data.map((lead) => (
                <tr
                  key={lead.id}
                  className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150"
                >
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="text-xs font-medium text-gray-900 dark:text-white">
                        {lead.updated_at}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="text-xs font-medium text-gray-900 dark:text-white">
                          {lead.first_name} {lead.last_name}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="text-xs text-gray-900 dark:text-white">
                      {lead.phone}
                    </div>
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="text-xs text-gray-900 dark:text-white">
                      {lead.email}
                    </div>

                    {/* <button
                      onClick={() => handleStatus(person.status_persona_id, person.numero_persona)}
                      className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${person.status_persona_id === '1'
                        ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                        : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                        }`}
                      title="status"
                    > */}

                    {/* <button
                      onClick={() => handleOpenAccessManagementModal(person.identificacion, `${person.name_persona}`,person.status_persona_id, person.numero_persona)}
                      className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${person.status_persona_id === '1'
                        ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                        : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                        }`}
                      title="status"
                    >
                      {updating && updatePersonId === person.numero_persona ? (
                        <>
                          <Icon name="loading" className="w-4 h-4 animate-spin" />
                        </>
                      ) : (
                        <>
                        </>
                      )}

                      {person.status_persona_id === '1' ? "Activo" : "Inactivo"}
                    </button> */}
                  </td>


                  <td className="px-6 py-2 whitespace-nowrap text-sm font-medium">
                    <div className="flex items-center justify-center space-x-1">
                      <button
                        // onClick={() => handleAddPhoto(person.identificacion)}
                        disabled = {true}
                        className="p-2 text-gray-100 hover:text-green-900 hover:bg-green-50 dark:text-green-400 dark:hover:text-green-300 dark:hover:bg-green-900/20 rounded-lg transition-colors"
                        title="Info"
                      >
                        <Icon name="eye" className="w-4 h-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      {totalPages > 1 && (
        <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            pageSize={pageSize}
            total={total}
            onPageChange={onPageChange}
          />
        </div>
      )}





    </div>
  );
};